import React from "react";
import { useTranslation } from "react-i18next";
import SocialLinks from "../components/SocialLinks";
import { useDemoBooking } from "../components/DemoBookingDialog";

const MAP_BASE =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d234.986814797763!2d114.20740272638663!3d22.292012094124832!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x34040111d896ab89%3A0xb7508b956316ca8d!2sTechnology%20Plaza!5e0!3m2!1s";

const Contact = () => {
  const { t, i18n } = useTranslation();
  const { openBooking } = useDemoBooking();
  const mapLang = i18n.resolvedLanguage === "zh-HK" ? "zh-TW" : "en";

  return (
    <section id="contact" className="contact">
      <div className="wrap">
        <header className="contact-head">
          <h2>{t("contact.title")}</h2>
          <p>{t("contact.intro")}</p>
          <button type="button" className="btn btn-green contact-book" onClick={openBooking}>
            {t("nav.bookDemo")}
          </button>
        </header>
        <div className="contact-facts">
          <dl>
            <div>
              <dt>{t("contact.location")}</dt>
              <dd>{t("footer.address")}</dd>
            </div>
            <div>
              <dt>{t("contact.phone")}</dt>
              <dd>
                <a href="tel:+85298559349">+852 9855 9349</a>
              </dd>
            </div>
            <div>
              <dt>{t("contact.email")}</dt>
              <dd>
                <a href="mailto:sales@virpluz.io">sales@virpluz.io</a>
              </dd>
            </div>
          </dl>
          <SocialLinks />
        </div>
      </div>
      <div className="contact-map">
        <iframe
          title={t("contact.mapTitle")}
          src={`${MAP_BASE}${mapLang}!2shk!4v1747812831217!5m2!1s${mapLang}!2shk`}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </section>
  );
};

export default Contact;
